import language from "#scripts/translation";

export const calendarItem = (obj) => {
    let eventLink = "/event";
    let target = "";
    if (window.serverdata.configMeta.aim.calendar?.useCustomEvents) {
        eventLink = "/event_custom";
    } else if (window.serverdata.configMeta.aim.calendar?.friskusEventUrl) {
        eventLink = window.serverdata.configMeta.aim.calendar?.friskusEventUrl;
        target = ` aria-label="${obj.eventName} (${language("NAV_OPEN_I_NEW")})" target="_blank"`;
    }

    return `
        <div class="calendar__item">
            <div class="row row-eq-height calendar__item_grid">
            <div class="calendar__date-container">
                <div class="cpcal__datespace h-100">
                <span class="calendar__item__date">${obj.itemDay}</span>
                <span class="calendar__item__month">${obj.itemMonth}</span>
                </div>
            </div>
            <div class="calendar__info-container">
                <div>
                <a href="${eventLink}/${obj.eventId}"${target} class="calendar__item__link">${obj.eventName}</a>
                </div>
                <div>
                ${obj.eventLokasjonAdresse !== null && obj.eventLokasjonAdresse !== undefined ? `<p class="calendar__item__place">
                <span class="material-icons-outlined notranslate calendar__item__icon calendar__item__icon-place"></span>${obj.eventLokasjonAdresse}</p>` : ""}
                <p class="calendar__item__time-stamp">
                    <span class="material-icons-outlined notranslate calendar__item__icon calendar__item__icon-time"></span>
                    ${obj.itemFrom}
                </p>
                </div>
            </div>
            </div>
        </div>`;
};
